import * as React from "react";
import { forwardRef } from "react";
const SvgPasswordManagementScreenInvalidRuleIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 9, height: 9, fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#DA291C", d: "M5.295 4.5 8.835.96A.564.564 0 0 0 8.22.043a.6.6 0 0 0-.182.122l-3.54 3.54L.96.165a.56.56 0 0 0-.796 0 .564.564 0 0 0 0 .795l3.54 3.54-3.54 3.54a.564.564 0 0 0 .614.917.6.6 0 0 0 .183-.122l3.54-3.54 3.539 3.54a.56.56 0 0 0 .796 0 .564.564 0 0 0 0-.795z" }));
const ForwardRef = forwardRef(SvgPasswordManagementScreenInvalidRuleIcon);
export { ForwardRef as ReactComponent };
